// src/utils/DateTimeFormatter.js

export const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', { timeZone: 'UTC' }); // Formato giorno/mese/anno in UTC
};

export const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'UTC' });
};

export const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${date.toLocaleDateString('it-IT', { timeZone: 'UTC' })} ${date.toLocaleTimeString('it-IT', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' })}`;
};
